module.exports = __webpack_public_path__ + "img/recipe-cost-icon.7ae09ad3.png";